import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

// hooks
import useOnClickOutside from '@/hooks/useOnClickOutside';

const SortBtn = ({ sorts, setQuerySort, label }) => {
  const ref = useRef();
  const [isOpen, setOpen] = useState(false);
  useOnClickOutside(ref, () => setOpen(false));

  return (
    <div
      ref={ref}
      className={`bra-sortBtn ${isOpen ? 'bra-sortBtn--open' : ''}`}
    >
      <button
        type='button'
        className='bra-btnIcon bra-btnIcon--sort bra-btnIcon--reverse  bra-btnIcon--text'
        onClick={() => setOpen(!isOpen)}
      >
        <span className='bra-btnIcon__wrap'>
          <i className='bra-icn bra-icn__icn-sort' />
        </span>
        <span className='bra-btnIcon__text'>{label}</span>
      </button>
      {sorts && (
        <ul className='bra-sortDropdown'>
          {sorts.map(sort => (
            <li key={sort.code} className='bra-sortDropdown__item'>
              <input
                id={sort.code}
                className='bra-sortDropdown__radio'
                type='radio'
                checked={sort.selected}
                name='sort'
                onChange={() => setQuerySort(sort.code)}
              />
              <span className='bra-sortDropdown__placeholder'>
                <i
                  className='bra-icn bra-icn__yes'
                  data-class=' bra-icn__yes'
                />
              </span>
              <label htmlFor={sort.code} className='bra-sortDropdown__label'>
                {sort.name}
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

SortBtn.propTypes = {
  sorts: PropTypes.arrayOf(PropTypes.shape()),
  setQuerySort: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

SortBtn.defaultProps = {
  sorts: null,
};

export default SortBtn;
